module.exports = __webpack_public_path__ + "img/20200309155248512.92f98e5f.jpg";